export interface IResultData<T> {
  data: T;
  code: number;
  message: string;
}

export function isIResultData<T>(data: unknown): data is IResultData<T> {
  return (
    typeof data === 'object' &&
    data !== null &&
    !Array.isArray(data) &&
    'code' in data &&
    'message' in data &&
    'data' in data
  );
}
